<template>
  <div id="footer" class="acea-row row-middle">
    <template v-for="(item, index) in footerList">
      <a
        v-if="item.url === '/customerService' && kfOpenAsTopNavigate"
        :key="'kf-' + index"
        href="javascript:;"
        style="height: 100%;"
        class="item am-cf"
        :class="{ on: item.url == $route.path }"
        @click.prevent="openKfTop"
      >
        <div
          class="iconfont"
          style="padding:0; height: 0.6rem !important; display:flex;align-items:center;justify-content:center;width: 100%;"
        >
          <img
            style="height: auto;width:0.7rem ;"
            v-if="item.url == $route.path"
            :src="item.icon1"
          />
          <img
            style="height: auto;width:0.6rem ;"
            v-if="item.url != $route.path"
            :src="item.icon2"
          />
        </div>
        <div style="line-height:0.4rem;height:0.4rem;">
          {{ item.name }}
        </div>
      </a>
      <router-link
        v-else
        :key="'r-' + index"
        style="height: 100%;"
        :to="item.url"
        class="item am-cf"
        :class="{ on: item.url == $route.path }"
      >
        <div
          class="iconfont"
          style="padding:0; height: 0.6rem !important; display:flex;align-items:center;justify-content:center;width: 100%;"
        >
          <img
            style="height: auto;width:0.7rem ;"
            v-if="item.url == $route.path"
            :src="item.icon1"
          />
          <img
            style="height: auto;width:0.6rem ;"
            v-if="item.url != $route.path"
            :src="item.icon2"
          />
        </div>
        <div style="line-height:0.4rem;height:0.4rem;">
          {{ item.name }}
        </div>
      </router-link>
    </template>
  </div>
</template>
<script>
import $store from "../store";
import { isKfHttpOnHttpsPage } from "@utils/index";

export default {
  name: "Footer",
  props: {},
  computed: {
    kfOpenAsTopNavigate() {
      return isKfHttpOnHttpsPage($store.state.app.kf);
    }
  },
  data: function() {
    return {
      footerList: [
        {
          name: "首页",
          icon1: require("@/assets/images/img/img/icon_home_y.png"),
          icon2: require("@/assets/images/img/img/icon_home_y.png"),
          url: "/"
        },
        {
          name: "理财",
          icon1: require("@/assets/images/img/img/icon_zx_y.png"),
          icon2: require("@/assets/images/img/img/icon_zx_y.png"),
          url: "/category"
        },
        {
          name: "客服",
          icon1: require("@/assets/images/img/img/rijin.png"),
          icon2: require("@/assets/images/img/img/rijin.png"),
          url: "/customerService"
        },
        {
          name: "我的",
          icon1: require("@/assets/images/img/img/icon_wode_y.png"),
          icon2: require("@/assets/images/img/img/icon_wode_y.png"),
          url: "/user"
        },
        {
          name: "申请退出",
          icon1: require("@/assets/images/img/img/kefu_icon_kf.png"),
          icon2: require("@/assets/images/img/img/kefu_icon_kf.png"),
          url: "/apply-exit"
        }
      ]
    };
  },
  methods: {
    openKfTop() {
      const kf = String($store.state.app.kf || "").trim();
      if (kf) {
        window.location.href = kf;
      }
    }
  }
};
</script>
<style type="text/css">
.iconfont {
  width: 0.6rem;
  height: 0.6rem !important;
  line-height: 0.55rem !important;
  padding: 2px;
  margin: 0 auto;
}
.iconfont img {
  width: 100%;
  height: 100%;
  display: block;
}
</style>
